



























import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Search extends Vue {
  public value = '';
  public sameType: RecordItem[] = [];

  public back() {
    this.$router.back();
  }
  public beforeMount() {
      this.$store.commit('fetchTags');
      this.$store.commit('fetchRecord');
      this.value = this.$store.state.searchWord || '';

  }

  public search() {
    if (!this.value) {
      return this.$message(
        {
          message: '请输入数据',
          type: 'warning',
          duration: 1000,
          offset: 200,
        },
      );
    }
    this.$store.commit('search', this.value);
    this.sameType = this.$store.state.tallyRecord.filter(
        (item: RecordItem) => {
          return item.search.indexOf(this.value) > -1;
        },
      );
    this.$message(
      {
        message: '搜索完毕',
        type: 'success',
        duration: 1000,
        offset: 200,
      },
    );
    }
}
